export default __webpack_public_path__ + "7f0a8d7ac0ffca909ad3553cff01f8a0.png";